import request from '@/utils/request'

// 获取用户自己名下的组织
export function organization() {
  return request({
    url: '/base/system/base/organization/getOrgznizationAndUserTree',
    method: 'post',
  })
}
// 个人权限授权 权限分配 -获取功能、按钮权限列表
export function get_system_function_buttonByuser(params) {
  return request({
    url: '/base/system/function/manager/get_system_function_buttonByuser',
    method: 'get',
    params
  })
}